import * as React from "react"
import {NavLink} from "../navLink";
import {graphql, useStaticQuery} from "gatsby";
import {machPath} from "../../../utils/slug";
import {useLocation} from "@reach/router";

export const CamstaNavigation = () => {

    const {allMarkdownRemark} = useStaticQuery<GatsbyTypes.CamstaNavQuery>(graphql`
            query CamstaNav {
              allMarkdownRemark(
            filter: {frontmatter: {menu: {eq: "キャムスタ！"}}}
            sort: {frontmatter: {date: ASC}}
            ) {
              nodes {
                    frontmatter {
                        title
                        slug
                    }
                }
              }
            }
  `)
    const {nodes} = allMarkdownRemark
    const location = useLocation()

    return (
        <>
            <NavLink title="キャムスタ！トップ" link="/camsta/"/>
            <div className="mt-4">
            {
                nodes.map((node,index)=> {
                    return (<NavLink key={index} link={node.frontmatter!.slug!} title={node.frontmatter!.title!} isBold={ machPath(node.frontmatter!.slug!, location.pathname) }/>)
                })
            }
            </div>
        </>
    )
}
